import {
  Box,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Table,
  Typography,
} from "@mui/material";
import { useEffect, useReducer, useState } from "react";
import FuseLoading from "@fuse/core/FuseLoading";
import { motion } from "framer-motion";
import axios from "axios";
import fileDownload from "js-file-download";
import { useSelector } from "react-redux";
import { getDepartmentByCompany } from "src/app/main/departments/DepartmentServices";
import moment from "moment";
import FuseScrollbars from "@fuse/core/FuseScrollbars";
import PaySlipTableHead from "./PaySlipTableHead";
import PaySlipTableBody from "./PaySlipTableBody";
import { deletePaySlips } from "../PaySlipServices";

function FiltreReducer(filtre, action) {
  const temp = { ...filtre };
  if (action.type !== "page") {
    temp.page = 1;
  }
  if (action.type === "disableAll") {
    Object.entries(temp).forEach(([key, value]) => {
      temp[key] = undefined;
    });

    return temp;
  }
  temp[action.field] = action.value;

  return temp;
}

export default function PaySlipTable() {
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [data, setData] = useState([]);
  const [order, setOrder] = useState({
    direction: "asc",
    id: null,
  });
  const [refreshTable, setRefreshTable] = useState(false);
  const [filtre, dispatchFiltre] = useReducer(FiltreReducer, {
    month: undefined,
    year: undefined,
    created_at: undefined,
    date_download: undefined,
    code: undefined,
    department: undefined,
    first_name: undefined,
    last_name: undefined,
    page: 1,
    rowsPerPage: 20,
  });

  const [infoData, setInfoData] = useState({
    nextPage: undefined,
    prevPage: undefined,
    total: 0,
    currentPage: 1,
  });
  const user = useSelector((state) => state.user);
  useEffect(() => {
    getDepartmentByCompany(user.company_id).then((res) => {
      console.log(res.data);
      setDepartments(res.data);
    });
  }, []);

  useEffect(() => {
    if (order.id) {
      submitFilter();
    }
  }, [order]);

  const permissions = useSelector((state) => {
    return state.user.get_role.get_permissions;
  });
  const finalPermissions = [];
  for (let i = 0; i < permissions.length; i++) {
    finalPermissions.push(permissions[i].nom);
  }

  useEffect(() => {
    submitFilter();
  }, [filtre]);

  function handleRequestSort(event, property) {
    const id = property;
    let direction = "desc";

    if (order.id === property && order.direction === "desc") {
      direction = "asc";
    }
    setOrder({
      direction,
      id,
    });
  }

  function handleSelectAllClick(event) {
    if (event.target.checked) {
      const temp = [...selected];
      temp[filtre.page] = data.data.map((n) => n.id);
      setSelected(temp);
      return;
    }
    const temp = [...selected];
    temp[filtre.page] = [];
    setSelected(temp);
  }

  function handleDeselect() {
    setSelected([]);
  }

  function handleCheck(event, id) {
    const selectedIndex = selected[filtre.page]?.indexOf(id);
    const newSelected = [...selected];
    if (selectedIndex === undefined) {
      newSelected[filtre.page] = [id];
    } else if (selectedIndex === -1) {
      newSelected[filtre.page] = [...newSelected[filtre.page], id];
    } else if (selectedIndex === 0) {
      newSelected[filtre.page] = selected[filtre.page]?.slice(1);
    } else if (selectedIndex === selected[filtre.page]?.length - 1) {
      newSelected[filtre.page] = selected[filtre.page]?.slice(0, -1);
    } else if (selectedIndex > 0) {
      newSelected[filtre.page] = newSelected[filtre.page]
        ?.slice(0, selectedIndex)
        .concat(newSelected[filtre.page]?.slice(selectedIndex + 1));
    }
    console.log("cou==>", newSelected[filtre.page], id);

    setSelected(newSelected);
  }

  function handleChangePage(event, value) {
    dispatchFiltre({
      type: "page",
      field: "page",
      value,
    });
  }

  function handleChangeRowsPerPage(event) {
    dispatchFiltre({
      field: "rowsPerPage",
      value: event.target.value,
    });
  }
  function getFilters() {
    let existFilter = false;

    Object.entries(filtre).forEach(([key, value]) => {
      if (filtre[key] !== undefined) existFilter = true;
    });

    return existFilter;
  }
  if (loading) {
    return <FuseLoading />;
  }

  if (data.length === 0) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { delay: 0.1 } }}
        className="flex flex-1 items-center justify-center h-full"
      >
        <Typography color="textSecondary" variant="h5">
          Aucun Décompte à afficher!
        </Typography>
        {getFilters() && (
          <Button
            className="ml-10"
            variant="contained"
            onClick={desactiverFiltre}
          >
            Désactiver filtres
          </Button>
        )}
      </motion.div>
    );
  }

  function submitFilter() {
    const params = {};
    Object.assign(params, filtre.month && { ...params, month: filtre.month });
    Object.assign(params, filtre.year && { ...params, year: filtre.year });
    Object.assign(
      params,
      filtre.creation_date && { ...params, creation_date: filtre.creation_date }
    );
    Object.assign(params, filtre.code && { ...params, code: filtre.code });
    Object.assign(params, filtre.page && { ...params, page: filtre.page });
    Object.assign(
      params,
      filtre.first_name && { ...params, first_name: filtre.first_name }
    );
    Object.assign(
      params,
      filtre.last_name && { ...params, last_name: filtre.last_name }
    );
    Object.assign(
      params,
      filtre.department && { ...params, department: filtre.department }
    );
    Object.assign(
      params,
      filtre.created_at && {
        ...params,
        created_at: moment(filtre.created_at).format("YYYY-MM-DD"),
      }
    );
    Object.assign(
      params,
      filtre.date_download && {
        ...params,
        date_download: moment(filtre.date_download).format("YYYY-MM-DD"),
      }
    );
    Object.assign(
      params,
      order.id && { order_by: order.id, order_direction: order.direction }
    );

    setLoading(true);
    axios
      .get("api/payslip/search", { params })
      .then((res) => {
        setData(res.data.payslips);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        alert(err);
      });
  }

  function disableSingleFiltre(single) {
    dispatchFiltre({
      field: single,
      value: undefined,
    });
    submitFilter();
  }
  function desactiverFiltre() {
    dispatchFiltre({
      type: "disableAll",
    });
    setRefreshTable(!refreshTable);
  }
  const deleteSinglePaySlip = (id) => {
    if (confirm("Etes-vous sûr de vouloir continuer?")) {
      setLoading(true);
      deletePaySlips([id])
        .then((res) => {
          submitFilter();
          alert("Fiche de paie supprimé avec succés");
        })
        .catch((err) => {
          alert(
            "Une erreur s'est produite lors de la suppression de la fiche de paie"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const deleteSelectedPaySlips = () => {
    if (confirm("Etes-vous sûr de vouloir continuer?")) {
      setLoading(true);
      deletePaySlips(selected)
        .then((res) => {
          submitFilter();
          alert("Bulletins de paie supprimé avec succés");
        })
        .catch((err) => {})
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const checkSelected = (id) => {
    if (selected[filtre.page] && selected[filtre.page].indexOf(id) !== -1) {
      return true;
    }
    return false;
  };

  if (data?.data.length === 0) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { delay: 0.1 } }}
        className="flex flex-1 items-center justify-center h-full"
      >
        <Typography color="textSecondary" variant="h5">
          Aucune donnée à afficher!
        </Typography>
        {getFilters() && (
          <Button
            className="ml-10"
            variant="contained"
            onClick={desactiverFiltre}
          >
            Désactiver filtres
          </Button>
        )}
      </motion.div>
    );
  }

  return (
    <FuseScrollbars className="grow overflow-x-auto">
      {filtre.code && (
        <Chip label="Code" onDelete={() => disableSingleFiltre("code")} />
      )}
      {filtre.first_name && (
        <Chip
          label="Prénom"
          onDelete={() => disableSingleFiltre("first_name")}
        />
      )}
      {filtre.last_name && (
        <Chip label="Nom" onDelete={() => disableSingleFiltre("last_name")} />
      )}
      {filtre.department && (
        <Chip
          label="Département"
          onDelete={() => disableSingleFiltre("department")}
        />
      )}
      {filtre.month && (
        <Chip label="Mois" onDelete={() => disableSingleFiltre("month")} />
      )}
      {filtre.year && (
        <Chip label="Année" onDelete={() => disableSingleFiltre("year")} />
      )}
      {filtre.created_at && (
        <Chip
          label="Date création"
          onDelete={() => disableSingleFiltre("created_at")}
        />
      )}
      {filtre.date_download && (
        <Chip
          label="Date téléchargement"
          onDelete={() => disableSingleFiltre("date_download")}
        />
      )}

      <Table
        stickyHeader
        className="min-w-xl"
        aria-labelledby="tableTitle"
        size="small"
      >
        <PaySlipTableHead
          selectedProductIds={selected[filtre.page]}
          order={order}
          onSelectAllClick={handleSelectAllClick}
          onRequestSort={handleRequestSort}
          rowCount={data.data.length}
          onMenuItemClick={handleDeselect}
          deleteSelectedPaySlips={deleteSelectedPaySlips}
          setData={setData}
          setLoading={setLoading}
          filtre={filtre}
          dispatchFiltre={dispatchFiltre}
          submitFilter={submitFilter}
          permissions={finalPermissions}
          departments={departments}
        />
        <PaySlipTableBody
          rows={data.data}
          checkSelected={checkSelected}
          handleCheck={handleCheck}
          deleteSinglePaySlip={deleteSinglePaySlip}
        />
      </Table>
      <Stack spacing={2} className="flex flex-row items-center">
        <Pagination
          count={Math.ceil(data.total / (filtre.rowsPerPage || 20))}
          page={filtre.page}
          onChange={handleChangePage}
          color="secondary"
          showFirstButton
          showLastButton
        />
        <Box sx={{ minWidth: 100 }}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Résultat par page
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filtre.rowsPerPage || 20}
              label="Résultat par page"
              onChange={handleChangeRowsPerPage}
            >
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
              <MenuItem value={200}>200</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Stack>
    </FuseScrollbars>
  );
}
